import React, { createContext, useState, useEffect, useContext } from 'react';

// Create a theme context
const ThemeContext = createContext();

// Theme provider component
export function ThemeProvider({ children }) {
  // Check if theme preference exists in local storage, otherwise use dark theme as default
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'dark'; // Default to dark if nothing saved
  });

  // Update theme class on document when theme changes
  useEffect(() => {
    const root = document.documentElement;

    // Remove previous theme class
    root.classList.remove('light', 'dark');

    // Add the new theme class
    root.classList.add(theme);

    // Store in localStorage
    localStorage.setItem('theme', theme);

    // Update meta theme color for mobile browsers (optional, but good practice)
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute(
        'content',
        theme === 'dark' ? '#1e2130' : '#ffffff' // Adjust these colors if your Tailwind theme uses different base colors
      );
    }
  }, [theme]);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'dark' ? 'light' : 'dark'));
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Custom hook to use the theme context
export function useTheme() {
  return useContext(ThemeContext);
}